import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=1b6996d0&scoped=true"
import script from "./channel.vue?vue&type=script&lang=ts"
export * from "./channel.vue?vue&type=script&lang=ts"
import style0 from "./channel.vue?vue&type=style&index=0&id=1b6996d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6996d0",
  null
  
)

export default component.exports